$(document).ready(function () {
    $(".downloadTab_text:first-child ").addClass('downloadTab_active');
    $(".downloadCollection[data-id='one']").show();
    // 首先确保第一个父标签中的 .downloadCollection_bottom1 显示
    $(".downloadCollection[data-id='one']").each(function () {
        // 找到当前元素最近的父标签 .downloadCollection_conter
        var $parentConter = $(this).closest('.downloadCollection_conter');
        // 输出找到的父级元素，以便确认选择正确
        // 示例：添加一个类名或者进行其他操作
        $parentConter.addClass('downloadCollection_conter1');
    });
    $('.downloadCollection_conter1').each(function () {
        $('.downloadCollection_conter1').first().addClass('highlight');
        $('.highlight').children('.downloadCollection').find('.downloadCollection_bottom1').show();
        $('.highlight').children('.downloadCollection').find('.downloadCollection_title').addClass('downloadCollection_iconActive');

    })
    // 判断是否为手机端
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    var swiper
    // 如果是手机端，则添加相应的类名
    if (isMobile) {
        $('.downloadTab').addClass('swiper');
        $('.downloadTab').addClass('downloadTab_swiper');
        $('.downloadTab_content').addClass('swiper-wrapper');
        $('.downloadTab_text').addClass('swiper-slide');
        swiper = new Swiper(".downloadTab_swiper", {
            slidesPerView: 2.5,
            spaceBetween: 8,
            slideToClickedSlide: true,
        });

    }
})
$('.downloadTab_text').click(function () {
    var id = $(this).data('id');
    $(this).addClass('downloadTab_active').siblings().removeClass('downloadTab_active');
    $('.downloadCollection_conter').each(function () {

        if ($(this).children('.downloadCollection').data('id') == id) {
            $(this).addClass('downloadCollection_conter1');
            $(this).children('.downloadCollection').show();
            $('.downloadCollection_conter1').each(function () {
                $('.downloadCollection_conter1').first().addClass('highlight');
                $('.highlight').children('.downloadCollection').find('.downloadCollection_bottom1').show();
                $('.highlight').children('.downloadCollection').find('.downloadCollection_title').addClass('downloadCollection_iconActive');

            })
        } else {
            $(this).removeClass('downloadCollection_conter1');
            $(this).removeClass('highlight');
            $(this).children('.downloadCollection').hide();
            $(this).find('.downloadCollection_bottom1').hide();
            $(this).find('.downloadCollection_title').removeClass('downloadCollection_iconActive');
        }
    });
})
$('.downloadCollection_title').click(function () {
    var $this = $(this);
    var $parent = $this.closest('.downloadCollection');
    var $content = $parent.find('.downloadCollection_bottom1');

    // 如果当前内容可见，则隐藏它并移除 active 类
    if ($content.is(":visible")) {
        $this.removeClass('downloadCollection_iconActive');
        $content.slideUp();
    } else {
        // 否则，显示当前内容并隐藏其他内容
        $this.closest('.downloadCollection_conter1').siblings().find('.downloadCollection_title').removeClass('downloadCollection_iconActive');
        $this.closest('.downloadCollection_conter1').siblings().find('.downloadCollection_bottom1').slideUp();

        $this.addClass('downloadCollection_iconActive');
        $content.slideDown();
    }
});


    // 点击视频触发弹窗（支持动态生成元素）
    $(document).on('click', '.downloadCollection_listVideo', function () {
        const videoUrl = $(this).data('url');   // mp4 / 外部视频
        const iframeId = $(this).data('id');    // YouTube ID

        if (!videoUrl && !iframeId) return;

        // 显示弹窗并阻止背景滚动
        $('.videoShadow').fadeIn(200).css('display','flex');
        $('.max-w-full').css("overflow", "hidden");

        // 重置视频 / iframe
        $('.videoShadow #activity_allVideo').hide().attr('src', '');
        $('.videoShadow #activity_allIframe').hide().attr('src', '');

        // 播放视频
        if (videoUrl && !iframeId) {
            $('.videoShadow #activity_allVideo').attr('src', videoUrl).show()[0].play();
        } else if (iframeId && !videoUrl) {
            const iframeUrl = `https://www.youtube.com/embed/${iframeId}?autoplay=1&mute=1&controls=1`;
            console.log(iframeUrl);
            $('.videoShadow #activity_allIframe').attr('src', iframeUrl).show();
        }
        // 如果同时存在 videoUrl 和 iframeId，优先 iframe
        else if (iframeId) {
            const iframeUrl = `https://www.youtube.com/embed/${iframeId}?autoplay=1&mute=1&controls=1`;
            $('.videoShadow #activity_allIframe').attr('src', iframeUrl).show();
        }
    });

    // 封装关闭弹窗函数
    function closeVideoPopup() {
        $('.videoShadow').fadeOut(200);
        $('.videoShadow #activity_allVideo').attr('src', '').hide();
        $('.videoShadow #activity_allIframe').attr('src', '').hide();
        $('.max-w-full').css("overflow", "auto");
    }

    // 点击遮罩空白关闭
    $('.videoShadow').on('click', function(e) {
        if (e.target === this) closeVideoPopup();
    });

    // 点击关闭按钮关闭
    $('.closureIcon').on('click', function() {
        closeVideoPopup();
    });

    // ESC 键关闭
    $(document).on('keydown', function(e) {
        if (e.key === "Escape") closeVideoPopup();
    });
